module.exports = __webpack_public_path__ + "static/vr-5-2s-c68e2df833ed63291793b4cf3866ec44.jpeg";